/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Laps_Efforts_NoneInputs */

const en_ui_laps_efforts_none = /** @type {(inputs: Ui_Laps_Efforts_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No efforts found`)
};

const de_ui_laps_efforts_none = /** @type {(inputs: Ui_Laps_Efforts_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Belastungen erkannt`)
};

/**
* | output |
* | --- |
* | "No efforts found" |
*
* @param {Ui_Laps_Efforts_NoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_laps_efforts_none = /** @type {((inputs?: Ui_Laps_Efforts_NoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Laps_Efforts_NoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_laps_efforts_none(inputs)
	return de_ui_laps_efforts_none(inputs)
});